module.exports = __webpack_public_path__ + "img/2.785ab237.jpg";